export const DEFAULT_EVENT_KEY = 'closed';
export const REDEEM_EVENT_KEY = 'redeem';
export const PROGRESS_EVENT_KEY = 'progress';
export const GIFTING_EVENT_KEY = 'gifting';
export const HELP_EVENT_KEY = 'help';
export const RETURN_EVENT_KEY = 'return';
